import CashClaimPlans from "./CashClaimPlans";

export default CashClaimPlans;
